import { render } from "./MainCarousel.vue?vue&type=template&id=20c7fdd2"
import script from "./MainCarousel.vue?vue&type=script&lang=js"
export * from "./MainCarousel.vue?vue&type=script&lang=js"

import "./MainCarousel.vue?vue&type=style&index=0&id=20c7fdd2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__